var _g, _path, _path2, _path3, _path4, _path5, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFirst(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 41,
    viewBox: "0 0 76 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_115_12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.2863 0L68.9902 0.136691L32.841 38H3.99017L40.2863 0Z",
    fill: "url(#paint0_linear_115_12)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.7558 0C16.6986 0 21.5157 4.28164 21.5157 9.56026C21.5157 11.2026 21.0481 12.7498 20.2246 14.1025C19.8273 14.7561 19.7569 15.5587 20.0052 16.2868L21.4992 20.647C21.5985 21.1186 21.2261 21.5157 20.7998 21.5157C20.6881 21.5157 20.5763 21.4909 20.4646 21.4289L16.8062 18.8764C16.3592 18.5662 15.8295 18.3966 15.2998 18.3966C15.035 18.3966 14.7701 18.4379 14.5176 18.5207C13.3465 18.9095 12.0842 19.1205 10.7599 19.1205C4.81714 19.1205 1.90735e-06 14.8389 1.90735e-06 9.56026C1.90735e-06 4.28164 4.81301 0 10.7558 0ZM10.7558 17.9291C11.9187 17.9291 13.0568 17.7471 14.1369 17.3872C14.5094 17.2631 14.9025 17.201 15.2957 17.201C16.0778 17.201 16.8352 17.441 17.489 17.896L19.8604 19.5507L18.8754 16.6715C18.5071 15.5918 18.6271 14.4293 19.2065 13.4779C19.9473 12.2616 20.3239 10.942 20.3239 9.56026C20.3239 4.94767 16.0323 1.19555 10.7599 1.19555C5.48757 1.19555 1.19602 4.94767 1.19602 9.56026C1.19602 14.1728 5.48757 17.925 10.7599 17.925L10.7558 17.9291Z",
    fill: "#003851"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.25993 7.16919H16.2558C16.5209 7.16919 16.7358 7.38404 16.7358 7.64907V7.88487C16.7358 8.14989 16.5209 8.36474 16.2558 8.36474H5.25993C4.9948 8.36474 4.77988 8.14989 4.77988 7.88487V7.64907C4.77988 7.38404 4.9948 7.16919 5.25993 7.16919Z",
    fill: "#003851"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.18665 10.7557H10.2066C10.4717 10.7557 10.6866 10.9706 10.6866 11.2356V11.4714C10.6866 11.7364 10.4717 11.9513 10.2066 11.9513H5.18665C4.92152 11.9513 4.7066 11.7364 4.7066 11.4714V11.2356C4.7066 10.9706 4.92152 10.7557 5.18665 10.7557Z",
    fill: "#003851"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M36.0634 23.1954C40.2226 23.1954 43.5995 19.8606 43.5995 15.739C43.5995 11.6173 40.2291 8.28259 36.0634 8.28259C31.8976 8.28259 28.5272 11.6173 28.5272 15.739C28.5272 19.8606 31.8976 23.1954 36.0634 23.1954ZM36.0634 10.1531C39.1795 10.1531 41.7155 12.6622 41.7155 15.7454C41.7155 18.8286 39.1795 21.3378 36.0634 21.3378C32.9472 21.3378 30.4113 18.8286 30.4113 15.7454C30.4113 12.6622 32.9472 10.1531 36.0634 10.1531Z",
    fill: "#003851"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M41.1483 26.1754H30.9785C24.4332 26.1754 19.1136 31.4387 19.1136 37.9147V39.4046C19.1136 39.9206 19.5374 40.3335 20.0524 40.3335C20.5674 40.3335 20.9912 39.9142 20.9912 39.4046V37.9147C20.9912 32.4707 25.4697 28.0394 30.9719 28.0394H41.1417C46.6439 28.0394 51.1225 32.4707 51.1225 37.9147V39.4046C51.1225 39.9206 51.5463 40.3335 52.0613 40.3335C52.5763 40.3335 53 39.9142 53 39.4046V37.9147C53 31.4387 47.6805 26.1754 41.1352 26.1754H41.1483Z",
    fill: "#003851"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_115_12",
    x1: 3.99017,
    y1: 19,
    x2: 68.9902,
    y2: 19,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.141667,
    stopColor: "#C0CE54",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.426667,
    stopColor: "#C0CE54",
    stopOpacity: 0.21
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.631667,
    stopColor: "#6EBA72",
    stopOpacity: 0.59
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811667,
    stopColor: "#00A19B",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003C56",
    stopOpacity: 0.8
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_115_12"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 65,
    height: 38,
    fill: "white",
    transform: "translate(11)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFirst);
export default __webpack_public_path__ + "static/media/first.6eee0a702cd938c5095952ddc34ca88b.svg";
export { ForwardRef as ReactComponent };